var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"power-chart-container"},[_c('div',{ref:"chartRef",staticClass:"chart-instance"})])
}
var staticRenderFns = []

export { render, staticRenderFns }